export default __webpack_public_path__ + "static/media/car-3.19f06277.png";